module.exports = __webpack_public_path__ + "img/working-is-fun.cf1c069d.png";